import { FC } from "react";

import { authClasses } from "../../pages/Auth/authClasses";

type DropProps = {
  value: string | number;
  options: Array<
    string | number | { value: string | number; label: string; disabled?: boolean }
  >;
  style?: object;
  setVal: (value: string) => void;
};

const FormDropdown: FC<DropProps> = (props) => {
  const { value, options, setVal, style } = props;
  const { input } = authClasses;
  return (
    <select
      value={String(value)}
      onChange={(e) => setVal(e.target.value)}
      required
      className={`${input} h-[46px] py-0`}
      style={style}
    >
      {options.map((option) => {
        const optionValue =
          typeof option === "string" || typeof option === "number"
            ? option
            : option.value;
        const optionLabel =
          typeof option === "string" || typeof option === "number"
            ? String(option)
            : option.label;
        const optionDisabled =
          typeof option === "string" || typeof option === "number"
            ? false
            : option.disabled === true;
        return (
          <option
            value={String(optionValue)}
            key={String(optionValue)}
            disabled={optionDisabled}
          >
            {optionLabel}
          </option>
        );
      })}
    </select>
  );
};

export default FormDropdown;
